import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/owners`, formData);
  },
  async findOne({ id }) {
    return axios.get(`/owners/${id}`);
  },
  async findAll() {
    return axios.get('/owners');
  },
  async findAllWithSettlementStatistic(formData) {
    return axios.get(`/owners/settlement-statistics/${formData.year}/${formData.month}`);
  },
  async findAllSettlements({ id }) {
    return axios.get(`/owners/${id}/settlements`);
  },
  async search(payload) {
    let url = `/owners/search?search=${payload.searchString}`
    return axios.get(url);
  },
  async findAllByStatus() {
    return axios.get(`/owners`);
  },
  async delete({ id }) {
    return axios.delete(`/owners/${id}`);
  },
  async update(formData) {
    return axios.put(`/owners/${formData.id}`, formData);
  },
  async statistics(formData) {
    return axios.get(`/owners/${formData.id}/statistics/${formData.year}${(formData.month !== null && formData.month !== undefined) ? ('/' + formData.month) : ''}`);
  }
};
